// extracted by mini-css-extract-plugin
export default {"swatch":"colour_swatch__s4YKV","container":"colour_container__j6C3B","active":"colour_active__+WzE+"};